import React, { useCallback, useState } from 'react';
import { View, StyleSheet, LayoutAnimation } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
const strings = {
    hide: 'See less',
    show: 'See more',
};
const CollapsibleSection = (props) => {
    const [expanded, setExpanded] = useState(false);
    const [shouldShowSeeMoreButton, setShouldShowSeeMoreButton] = useState(false);
    const onFlip = useCallback(() => {
        LayoutAnimation.configureNext({
            duration: 400,
            update: {
                duration: 200,
                delay: expanded ? 200 : 0,
                type: LayoutAnimation.Types.easeInEaseOut,
                property: LayoutAnimation.Properties.opacity,
            },
            create: {
                delay: expanded ? 0 : 200,
                duration: 200,
                type: LayoutAnimation.Types.easeInEaseOut,
                property: LayoutAnimation.Properties.opacity,
            },
            delete: {
                delay: expanded ? 0 : 200,
                duration: 200,
                type: LayoutAnimation.Types.easeInEaseOut,
                property: LayoutAnimation.Properties.opacity,
            },
        }, () => {
            if (props.scrollViewRef?.current) {
                props.scrollViewRef.current.scrollToEnd({ animated: true });
            }
        });
        setExpanded((value) => !value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expanded]);
    const colors = useColors();
    const onTextLayout = useCallback((event) => {
        const lines = event.nativeEvent.lines.length;
        if (lines === 3) {
            setShouldShowSeeMoreButton(true);
        }
    }, []);
    return (<View style={styles.container}>
      {expanded ? (<Text key="expanded-text" TextThin-14 OffBlack>
          {props.text}
        </Text>) : (<Text key="collapsed-text" TextThin-14 OffBlack numberOfLines={3} onTextLayout={onTextLayout}>
          {props.text}
        </Text>)}
      {!!shouldShowSeeMoreButton && (<>
          <Spacer h={1}/>
          <TouchableHighlight hoverOnLight underlayColor={colors.background.underlay} activeOpacity={1} onPress={onFlip}>
            {expanded ? (<View key="expanded-button" style={styles.row}>
                <Text Text-14 Primary>
                  {strings.hide}
                </Text>
              </View>) : (<View key="collapsed-button" style={styles.row}>
                <Text Text-14 Primary>
                  {strings.show}
                </Text>
              </View>)}
          </TouchableHighlight>
        </>)}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
export default CollapsibleSection;
